<div class="gameHeader" *ngIf="userData?.isMobileApp == 1">
    <button class="back leftbtn" (click)="appLobbyBack()">
        <a>
            <svg class="svgicon">
                <use xlink:href="assets/images/sprite-sheet.svg#icon-leftarrow"></use>
            </svg>
        </a>
    </button>
    <div class="pageIndicator" style="justify-content: space-between;">
        <div class="title">Lottery</div>
        <div class="userinfo">
            <div class="userName">{{userData?.playername}}</div>
            <div class="balanceWrap" innerHTML="{{userData?.balance | custCurrency}}"></div>
        </div>
    </div>
</div>
<div class="sectionWrapper" *ngIf="!showErrorPage">
    <ul class="gameList">
        <li *ngFor="let item of gameData;" routerLinkActive="active">
            <div class="button">
                <a href="/dge{{item.path}}" routerLink="/dge{{item.path}}">
                    <div class="extInfoWrap coming" *ngIf="item?.gameCode == 'TwoDMYANMAAR' || item?.gameCode == 'BichoRapido' || item?.gameCode ==  'MiniRoulette' || item?.gameCode == 'BingoSeventyFive3'">
                        <div class="blkWrap">
                            <div class="title">Coming Soon</div>
                        </div>
                    </div>
                    <div class="extInfoWrap active" *ngIf="item?.rootData?.jackpot">
                        <div class="blkWrap">
                            <div class="title">{{'dge.jackpot' | translate}}</div>
                            <div class="subtitle">
                                <div class="txt" innerHTML="{{125000 | custCurrency}}"></div>
                            </div>
                        </div>
                    </div>
                    <figure>
                        <div class="imgWrap">
                            <img src="assets/images/{{clientCode}}/lobbyIcon/{{item?.rootData?.gameIcon}}"
                                alt="game-{{item.gameName}}">
                        </div>
                        <figcaption>{{'common.'+ item?.gameCode | translate}}</figcaption>
                    </figure>
                    <div class="timerWrap" *ngIf="item?.rootData?.timer && diff_time[item.gameCode]?.fetchRuleStatus">
                        <div class="label">{{'dge.ends_in' | translate}}:</div>
                        <div class="timer">
                            <div class="box day" *ngIf="diff_time[item.gameCode]?.convention == 'day'">
                                <span class="num">{{diff_time[item.gameCode]?.shownTime[0]}}</span>
                                <span
                                    class="convention">{{diff_time[item.gameCode]?.shownTime[0] == 1 ? ' Day' : ' Days'}}</span>
                            </div>
                            <div class="box hour" *ngIf="diff_time[item.gameCode]?.convention == 'hr'">
                                <span class="num">{{diff_time[item.gameCode]?.shownTime[1]}}</span>
                                <span
                                    class="convention">{{diff_time[item.gameCode]?.shownTime[1] == 1 ? ' Hour' : ' Hours'}}</span>
                            </div>
                            <div class="box minute" *ngIf="diff_time[item.gameCode]?.convention == 'min'">
                                <span class="num">{{diff_time[item.gameCode]?.shownTime[2]}}</span>
                                <span
                                    class="convention">{{diff_time[item.gameCode]?.shownTime[2] == 1 ? ' M' : ' M'}}</span>
                            </div>
                            <div class="box second"
                                *ngIf="diff_time[item.gameCode]?.convention == 'min' || diff_time[item.gameCode]?.convention == 'sec'">
                                <span class="num">{{diff_time[item.gameCode]?.shownTime[3]}}</span>
                                <span
                                    class="convention">{{diff_time[item.gameCode]?.shownTime[3] == 1 ? ' S' : ' S'}}</span>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </li>
    </ul>
    <div class="buttonWrap myTicketbtn">
        <button (click)="loadResults()">{{'dge.view_results' | translate}}</button>
        <button routerLink="/dge/my-tickets" routerLinkActive="active"
            *ngIf="showButton && gameData.length > 0">{{'dge.view_ticket' | translate}}</button>
    </div>
</div>
<div style="margin: 0 auto; max-width: 1300px; color: #4e3b73; line-height: 1.5; letter-spacing: 0.02em; padding: 15px;"><strong style="margin-right: 5px; font-size: 14px; font-style: italic;"><i>{{'common.note' | translate}}</i></strong><p style="margin-top:5px;font-size: 13px;">{{'common.lobby_note1' | translate}}<br>{{'common.lobby_note2' | translate}}<br>{{'common.lobby_note3' | translate}}<br>{{'common.lobby_note4' | translate}}<br>{{'common.lobby_note5' | translate}}</p></div>
<div class="oopsDiv" *ngIf="showErrorPage">
    <div class="imgWrap">
        <img src="assets/images/oops.png">
    </div>
    <div class="msg">
        <p>{{'common.error_msg' | translate}}</p>
    </div>
</div>
       